import React from 'react';

import {Typography, Box, Container} from 'views/components';
import {Translate} from 'views/module';

const JobBoardTitle = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        px: {xs: 3, sm: 4, md: 6},
        py: {xs: 10, md: 14},
      }}
    >
      <Box
        sx={{
          maxWidth: 768, // ~max-w-3xl
          mx: 'auto',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 3, // space-y-6
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontWeight: 600,
            letterSpacing: '-0.02em',
            fontSize: {xs: '2.25rem', md: '3rem', lg: '3.75rem'},
            lineHeight: 1.1,
          }}
        >
          <Translate expression='jobBoard.JobBoardTitle.Title'/>
        </Typography>

        <Typography
          sx={{
            mx: 'auto',
            maxWidth: 672, // ~max-w-2xl
            fontSize: {xs: '1.125rem', md: '1.25rem'},
            color: 'text.secondary',
          }}
        >
          <Translate expression='jobBoard.JobBoardTitle.SubTitle'/>
        </Typography>
      </Box>
    </Container>
  );
};

JobBoardTitle.propTypes = {};

export default JobBoardTitle;
